import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from 'components/dialog'
import OneTimeSlotForm from './one-time-slot-form'

const useStyles = makeStyles(() => ({
  header: {
    borderBottom: 'none',
    paddingBottom: 0,
  },
}))

const OneTimeSlotDialog = ({
  facilities,
  onSuccess,
  triggerProps,
  initialType,
  compact,
}) => {
  const classes = useStyles()
  const trigger = compact ? (
    <IconButton
      color="primary"
      aria-label="Add one-time slot"
      title="Add one-time slot"
    >
      <AddOutlinedIcon />
    </IconButton>
  ) : (
    <Button
      variant="contained"
      color="primary"
      startIcon={<AddOutlinedIcon />}
      size="large"
      style={{ whiteSpace: 'nowrap' }}
      {...triggerProps}
    >
      Add One-Time Slot
    </Button>
  )
  return (
    <Dialog trigger={trigger} maxWidth="sm" fullWidth showCloseButton>
      {({ closeDialog }) => (
        <>
          <DialogTitle className={classes.header}>
            Add One-Time Slot
          </DialogTitle>
          <DialogContent>
            <Box pb={2}>
              <OneTimeSlotForm
                facilities={facilities}
                initialType={initialType}
                onSuccess={() => {
                  onSuccess && onSuccess()
                  closeDialog()
                }}
                onCancel={closeDialog}
              />
            </Box>
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default OneTimeSlotDialog
